import { AfterViewInit, Component, Inject, OnDestroy, OnInit, Renderer2, HostListener, ViewChild, ElementRef } from '@angular/core';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { retry, takeUntil, timeout,finalize  } from 'rxjs/operators';
import { timer } from 'rxjs';
import { ActivatedRoute, Router, RouterLink, } from '@angular/router';
import { SubscribeComponent } from 'src/app/templates/subscribe/subscribe.component';
import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, SlicePipe } from '@angular/common';
import { SpinnerComponent } from 'src/app/templates/spinner/spinner.component';
import { CategoryProduct } from 'src/_lib/interfaces/category-product';
import { CategoryProductService } from 'src/_lib/service/category-product.service';
import { CategoryTopDetailsComponent } from "./category-top-details/category-top-details.component";
import { SubCategoryComponent } from "./sub-category/sub-category.component";
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { MatDialog } from '@angular/material/dialog';
import { CategoryProductFilter } from 'src/_lib/interfaces/category-product-filter';
import { LoveItPopupComponent } from 'src/app/templates/featured-product/component/product-details/love-it-popup/love-it-popup.component';
import { environment } from 'src/environments/environment.prod';
import { CartService } from 'src/_lib/service/cart.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { StarArrayPipe } from 'src/_lib/pipes/star-array.pipe';
import { AffirmWidgetComponent } from 'src/app/templates/featured-product/component/affirm-widget/affirm-widget.component';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { FormsModule } from '@angular/forms';
import { TruncateHtmlPipe } from 'src/_lib/pipes/truncate-html.pipe';
import { SeoService } from 'src/_lib/service/seo.service';
import { BreadcrumbComponent } from 'src/app/templates/breadcrumb/breadcrumb.component';
import { SearchByVehicleService } from 'src/_lib/service/search-by-vehicle.service';
import { removeBackslash } from 'src/_lib/pipes/removebackslash.pipe';
import { CustomCurrencyPipe } from 'src/_lib/pipes/customCurrency.pipe';
import { PaypalWidgetComponent } from 'src/app/templates/featured-product/component/paypal-widget/paypal-widget.component';
import { WishlistPopupComponent } from 'src/app/templates/featured-product/component/product-details/wishlist-popup/wishlist-popup.component';
import { ProductService } from 'src/_lib/service/product.service';
import { wishlistPostDataInterface } from 'src/_lib/interfaces/request-interfaces/wishlist-popup.interface';
import { StripHtmlPipe } from 'src/_lib/pipes/stripHtml.pipe';
import { GtmService } from 'src/_lib/service/gtm.service';
import { HeaderService } from 'src/_lib/service/header.service';
import { CartVerifyPopupComponent } from 'src/app/templates/cart/component/cart-verify-popup/cart-verify-popup.component';
import { BrowserService } from 'src/_lib/service/browser.service';
import { SanitizeHtmlPipe } from 'src/_lib/pipes/sanitizeHtml';
import { CategoryService } from 'src/_lib/service/category.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';

@Component({
  selector: 'app-category-details',
  templateUrl: './category-details.component.html',
  styleUrls: ['./category-details.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgSwitch,
    NgSwitchCase,
    NgClass,
    FormsModule,
    SlicePipe,
    StarArrayPipe,
    TruncateHtmlPipe,
    RouterLink,
    SubscribeComponent,
    SpinnerComponent,
    CategoryTopDetailsComponent,
    SubCategoryComponent,
    BreadcrumbComponent,
    AffirmWidgetComponent,
    removeBackslash,
    CustomCurrencyPipe,
    PaypalWidgetComponent,
    StripHtmlPipe,
    SanitizeHtmlPipe,
    ShopByVehicleComponent
  ],
  host: { 'ngSkipHydration': 'true' }
})
export class CategoryDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  categoryKeyChangeSub: Subscription;
  private cancelApiCall$ = new Subject<void>();
  isLoading: boolean = true; // start true to prevent empty-content flash before first API call
  order_key: number = null;
  category_key: number = 0;
  parent_category_key: number = 0;
  category_name: string = '';
  allData: any;
  categoryData: any;
  subCategoryData: any;
  total_products: any;
  productDetailsData: any;
  initial_product_keys: any;
  initial_total_products: any;
  offset: number = 0;
  limit: number = 18;
  sort_by: string = "";
  closeIcon: string = environment.closeIcon;
  all_category_products: boolean = true;
  show_categories: boolean = true;
  brand_keys: string[] = [];
  size_keys: string[] = [];
  color_keys: string[] = [];
  feature_keys: string[] = [];
  custom_filter_keys: string[] = [];
  part_types: string[] = [];
  vehicle_search_form: {
    product_key: string,
    select_make: string,
    select_model: string,
    select_year: string,
    sub_model_1: string,
    sub_model_2: string,
    sub_model_3: string,
    category: string
  } = {
      product_key: '',
      select_make: '',
      select_model: '',
      select_year: '',
      sub_model_1: '',
      sub_model_2: '',
      sub_model_3: '',
      category: ''
    };
  vehicle_name: string = '';
  price_ranges: string[] = [];
  selectedPriceRanges: string[] = [];
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  imageBasePath: string = environment.imageBasePath;
  dynamicFilters: any[] = [];
  selectedFilters: { [key: string]: string[] } = {};
  showAllMap: { [key: string]: boolean } = {};
  showAllPrices = false;
  showAllCategory = false;
  totalPages: number = 0;
  totalPagesArray: number[] = [];
  currentPage: number = 1;
  pageNo: string = '';
  selectedImageIndex: number = 0;
  addToCartButtons: { [productVariationKey: string]: boolean } = {};
  disableCheckoutButton: boolean = false;
  lastFetchedCategoryKey: number | null = null;
  priceRanges = [
    { label: '$0-$100', value: '0-100' },
    { label: '$100-$200', value: '100-200' },
    { label: '$200-$300', value: '200-300' },
    { label: '$300-$400', value: '300-400' },
    { label: '$400-$500', value: '400-500' },
    { label: '$500+', value: '500-0' }
  ];
  inventoryDisabled: boolean = false;
  isSearchByVehicleDisabled: boolean = false;
  defaultSubtitle: boolean = false;
  hideSubtitle: boolean = false;
  paypalClientId: string = '';
  stickyFilterbtn: boolean = false;
  contact: string = environment.contact_no;
  formatted_contact: string = this.contact.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  paginationGroupSize: number = 15;
  categoryProductDisplaySettings: any;
  chTheme1 = environment.chTheme1;
  private showListener: any;
  private hideListener: any;
  private hiddenListener: any;
  //selectedGrid: string = 'grid-1';
  chTheme4 = environment.chTheme4;
  selectedGrid: string = '';
  showLastCategoryData: boolean = false;
  lastCategoryData: any;
  @ViewChild('productsSection', { static: false })
  productSectionId!: ElementRef;
  selectedFilterChips: { filterKey: string; filterTitle: string; itemId: string; itemName: string }[] = [];
  @ViewChild('breadcrumbSection', { static: false })
  breadcrumbSectionId!: ElementRef;
  scrollToProdSec: boolean = false;
  breadcrumbData: { category_key: number; name: string }[] = [];
  addToCartFlag: { [key: number]: boolean } = {};
  inventoryMessages: { availabilityMsg: string; urgencyMsg: string; pickupMsg: string; showBackorder: boolean } | null = null;
  categoryextendeddescription: string;
  corporateCustomer: string = '';
  merchantProductUrl: string = environment.merchantProductUrl;
  universalFilter: any = [];
  globalUniversalFilterSetting : number;
  isVehicleSidebar: boolean = false;

  constructor(
    private categoryProductService: CategoryProductService,
    private productHttp: ProductService,
    private comm: CommunicationService,
    private commonService: CommanpageService,
    private cartService: CartService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private router: Router,
    private seoService: SeoService,
    private searchByVehicleService: SearchByVehicleService,
    private headerService: HeaderService,
    private gtmService: GtmService,
    private browser: BrowserService,
    private categoryService: CategoryService,
    private sanitizer: DomSanitizer,
  ) {}

  async ngOnInit(): Promise<void> {
    this.onResize();
    this.corporateCustomer = this.browser.localStorage?.getItem('isCorporateUser') || '';
    this.paypalClientId = this.commonService.paypalClientIdDetails();
    this.inventoryDisabled = this.commonService.isInventoryDisabled();
    const vehicleBtnData = this.commonService.isSearchByVehicleDisabled();
    this.isSearchByVehicleDisabled = vehicleBtnData?.vehicle_search_all_pages;
    this.isVehicleSidebar = vehicleBtnData?.header_sidebar;
    this.defaultSubtitle = this.commonService.isDefaultSubtitle();
    this.hideSubtitle = this.commonService.isSubtitleHidden();

    if (this.browser.isBrowser) {
      this.vehicle_search_form = JSON.parse(this.browser.localStorage?.getItem('vehiclesearchForm') || 'null') || {};
      this.vehicle_name = this.browser.localStorage?.getItem('vehiclename') || "";
    }
    this.comm.vehiclenameSubject.subscribe(name => {
      this.vehicle_name = name
    });
       
    this.getRouteData();
    this.comm.cartItemRemoved$.subscribe((flag) => {
      if (flag) {
        this.setInitialAddToCartButtons();
        this.syncCartButtonStates();
      }
    });
    this.globalUniversalFilterSetting = this.commonService.isuniversalFilter();
  }

  onResize() {
    if (!this.browser.isBrowser) return;
    const width = this.browser.window?.innerWidth;
    if (width >= 992) this.paginationGroupSize = 15;
    else if (width >= 768) this.paginationGroupSize = 12;
    else this.paginationGroupSize = 9;
    this.totalPagesArray = this.getGroupedPages();
    this.setGridView();
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    if (!this.browser.isBrowser) return;
    this.stickyFilterbtn = (this.browser.window?.scrollY || 0) > 450;
  }

  ngAfterViewInit(): void {
    if (!this.browser.isBrowser) return;
    const doc = this.browser.doc;
    if (!doc) return;
    const sidebarEl = doc.getElementById('categoryProdFilter');
    if (!sidebarEl) return;
    // SHOW
    this.showListener = () => {
      this.renderer.setStyle(doc.documentElement, 'overflow', 'hidden');
    };
    // HIDE
    this.hideListener = () => {
      this.renderer.removeStyle(doc.documentElement, 'overflow');
    };
    // HIDDEN
    this.hiddenListener = () => {
      this.renderer.removeStyle(doc.documentElement, 'overflow');
      const backdrop = doc.querySelector('.offcanvas-backdrop');
      if (backdrop?.parentNode) {
        backdrop.parentNode.removeChild(backdrop);
      }
      sidebarEl.classList.remove('show');
    };
    sidebarEl.addEventListener('show.bs.offcanvas', this.showListener);
    sidebarEl.addEventListener('hide.bs.offcanvas', this.hideListener);
    sidebarEl.addEventListener('hidden.bs.offcanvas', this.hiddenListener);
  }

  async getRouteData() {
    combineLatest([this.route.params, this.route.queryParamMap])
      .subscribe(async ([params, queryParams]) => {
        const idParam: string = params['id'] || '';
        let categoryKey = 0;
        if (this.browser.isBrowser) {
          categoryKey = +((this.browser.localStorage?.getItem('selectedcategorykey')) || 0);
        }
        if (!categoryKey && idParam.startsWith('c')) {
          categoryKey = +idParam.substring(1);
        }
        this.isLoading = true;
        if (this.chTheme1 && this.browser.isBrowser) {
          const url = this.browser.window?.location.pathname;
          const normalize = (str: string): string => {
            return (str || '')
              .toLowerCase()
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/[^a-z0-9]/g, '');
          };
          const catModule = await import('src/assets/URL/category301.json');
          const catUrljson = catModule.default;
          const normalizedUrl = normalize(url);
          const catMatch = catUrljson.find((item: any) => normalize(item.key) === normalizedUrl,);
          if (catMatch) {
            this.router.navigate([catMatch.value]);
            return;
          }
        }
        if (!!categoryKey) {
          this.category_key = categoryKey;
          this.resetFilters();
          this.pageNo = params['pageCode'];
          if (this.pageNo) {
            this.currentPage = +this.pageNo;
            this.offset = (+this.pageNo - 1) * this.limit;
            this.totalPagesArray = this.getGroupedPages();
          }
          this.vehicle_search_form = JSON.parse(this.browser.localStorage?.getItem('vehiclesearchForm') || 'null') || {};
          this.size_keys = queryParams.getAll('sizeKey') || [];
          this.color_keys = queryParams.getAll('colorKey') || [];
          this.brand_keys = queryParams.getAll('brandKey') || [];
          this.feature_keys = queryParams.getAll('featureKey') || [];
          this.custom_filter_keys = queryParams.getAll('customFilterKey') || [];
          this.part_types = queryParams.getAll('partType') || [];
          this.universalFilter = queryParams.getAll('universal') || [];
          this.price_ranges = this.selectedPriceRanges = queryParams.getAll('priceRange') || [];
          this.selectedFilters = JSON.parse(queryParams.get('selectedFilters') || '{}');
          if (this.brand_keys?.length > 0) {
            this.selectedFilters['brand'] = [...this.brand_keys];
          }
          await this.getCategoryProductData();
        }
      },);
  }

  async getCategoryProductData() {
    this.isLoading = true;
    const data: CategoryProduct = {
      category_key: this.category_key,
      offset: this.offset,
      limit: this.limit,
      sort_by: this.sort_by,
      all_category_products: this.all_category_products,
      show_categories: this.show_categories,
      size_keys: this.size_keys?.length > 0 ? this.size_keys.join(",") : "",
      color_keys: this.color_keys?.length > 0 ? this.color_keys.join(",") : "",
      brand_keys: this.brand_keys?.length > 0 ? this.brand_keys.join(",") : "",
      feature_keys: this.feature_keys?.length > 0 ? this.feature_keys.join(",") : "",
      custom_filter_keys: this.custom_filter_keys?.length > 0 ? this.custom_filter_keys.join(",") : "",
      part_types: this.part_types?.length > 0 ? this.part_types.join(", ") : "",
      price_ranges: this.price_ranges?.length > 0 ? this.price_ranges.join(",") : "",
      universal_filter: this.universalFilter.join(",") || "",
      vehicle_make_keys: this.vehicle_search_form?.select_make || "",
      vehicle_model_keys: this.vehicle_search_form?.select_model || "",
      vehicle_year: this.vehicle_search_form?.select_year || "",
      vehicle_submodel1_keys: this.vehicle_search_form?.sub_model_1 || "",
      vehicle_submodel2_keys: this.vehicle_search_form?.sub_model_2 || "",
      vehicle_submodel3_keys: this.vehicle_search_form?.sub_model_3 || ""
    };
    this.cancelApiCall$.next();
    this.categoryProductService.categoryProductList(data)
    .pipe(
      timeout(15000),
      retry({
      count: 2,
      delay: () => timer(3000)
      }),
      finalize(() => {
        //this.isLoading = false;
      }),
      takeUntil(this.cancelApiCall$)
    )
    .subscribe({
      next: (response: any) => {
        const url = this.browser.window?.location?.href || '';
        this.allData = response[0].data;
        this.categoryProductDisplaySettings = this.allData.categoryProductDisplaySettings;
        this.setGridView();
        this.categoryData = this.allData.category;
        this.categoryextendeddescription = this.allData.category.category_extended_description;
        this.parent_category_key = this.categoryData.parent_category_key;
        if (this.pageNo === undefined && this.brand_keys?.length === 0) {
          if (this.categoryData.hard_link_url && url.toString() !== this.categoryData.hard_link_url) {
            const splitUrl = this.categoryData.hard_link_url.split('/');
            if (this.browser.isBrowser) {
              if (this.router.url != `/${splitUrl[splitUrl?.length - 2]}/${splitUrl[splitUrl?.length - 1]}`){
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.router.navigate([`${splitUrl[splitUrl?.length - 2]}/${splitUrl[splitUrl?.length - 1]}`]);
                return;
              }
            }
          }
        }
        this.subCategoryData = this.allData.sub_categories;
        this.showLastCategoryData = this.subCategoryData?.[0]?.category_key === this.categoryData?.parent_category_key
        if (this.showLastCategoryData) {
          this.lastCategoryData = this.subCategoryData?.[0];
        }
        this.subCategoryData?.sort((a: any, b: any) => a?.category_name?.localeCompare(b?.category_name));
        this.total_products = this.allData.total_products[0].total_products;
        this.totalPages = Math.ceil(this.total_products / this.limit);
        this.totalPagesArray = this.totalPagesArray = this.getGroupedPages();
        this.initial_total_products = this.allData.initial_total_products[0].initial_total_products;
        this.initial_product_keys = this.allData.initial_total_products[0].initial_product_keys;
        this.productDetailsData = this.allData.product_details || [];
        this.productDetailsData.map(product => {
            if(product?.add_to_cart == 'on' && product?.sku){
              if(product?.variation_add_to_cart == 'on'){
                this.addToCartFlag[product.product_key] = true
              }else{
                this.addToCartFlag[product.product_key] = false
              }
            }else if(product?.add_to_cart == 'off' && product?.sku){
              this.addToCartFlag[product.product_key] = false
            }else{
              this.addToCartFlag[product.product_key] = true
            }
          });
        this.categoryService.setLastCategoryKey(this.category_key);
        this.loadBreadcrumb(this.category_key);
         if (this.browser.isBrowser) {
          this.browser.window?.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
       
        if (this.scrollToProdSec || this.subCategoryData?.length == 0) {
          setTimeout(() => {
            this.scrollToProducts();
          }, 0);
        }
         } if (this.lastFetchedCategoryKey !== this.category_key) {
          this.getCategoryProductFilterData();
          this.lastFetchedCategoryKey = this.category_key;
        }
        this.calculateProductRatings();
        this.setInitialAddToCartButtons();
        this.syncCartButtonStates();
        this.isLoading = false;
      },
      error: (err) => {
        if (err?.name === 'TimeoutError') {
          console.warn('Category Products API timed out, retrying...');
          this.router.navigate(['/parts-and-accessories']);
        } else {
          console.error('Category Products API Error:', err);
        }
        this.isLoading = false;
      }
    });
  }

  loadBreadcrumb(key: number) {
    this.categoryService.getCategoryBreadcrumb(key).subscribe(res => {
      if (res[0]?.success) {
        this.breadcrumbData = res[0].data || [];
      } else {
        this.breadcrumbData = [];
        console.warn('Unexpected breadcrumb response', res);
      }
    });
  }

  setGridView(): void {
      const defaultGrid = this.categoryProductDisplaySettings?.[0]?.default_grid_view;
      switch (defaultGrid) {
        case 'Grid2':
          this.selectedGrid = 'grid-2';
          break;
        case 'Grid3':
          this.selectedGrid = 'grid-3';
          break;
        case 'Grid1':
        default:
          this.selectedGrid = 'grid-1';
      }
    if (this.browser.isBrowser) return;
    const width = this.browser.window?.innerWidth;
    if (width < 768) {
      this.selectedGrid = 'grid-1';
       this.browser.localStorage?.removeItem('selectedGrid');
      return;
    }
    const storedGrid = this.browser.localStorage?.getItem('selectedGrid');
    if (storedGrid) {
      this.selectedGrid = storedGrid;
      return;
    }
  }

  showGrid(grid: string): void {
    if (!this.browser.isBrowser) return;
    if ((this.browser.window?.innerWidth || 0) < 768) {
      this.selectedGrid = 'grid-1';
      return;
    }
    this.selectedGrid = grid;
    this.browser.localStorage?.setItem('selectedGrid', grid);
  }

  get showSideFilterCategories(): boolean {
    const view = this.categoryProductDisplaySettings?.[0]?.category_view;
    return [
      'do_not_show',
      'thumbnail_side_filters',
      'button_side_filters'
    ].includes(view);
  }

  getProductSubtitle(product: any): string {
    if (this.hideSubtitle) {
      return '';
    }
    if (this.defaultSubtitle) {
      return product?.tagline || '';
    }
    if (product?.tagline) {
      return product.tagline;
    }
    const specLabel = this.extractSpecificationValues(product?.specification_label1?.trim() || '');
    const specValue = this.extractSpecificationValues(product?.specification_value1?.trim() || '');
    if (specLabel || specValue) {
      return `${specLabel} ${specValue}`.trim();
    }
    if (product?.short_description) {
      return product.short_description;
    }
    return '';
  }

  extractSpecificationValues(htmlString: string): string {
    if (!htmlString) return '';
    if (!this.browser.doc) return '';
    const tempDiv = this.browser.doc.createElement('div');
    tempDiv.innerHTML = htmlString;
    const liElements = tempDiv.querySelectorAll('li');
    const values: string[] = [];
    liElements.forEach(li => {
      let text = li.textContent || '';
      text = this.fixEncoding(text);
      const parts = text.split(':');
      if (parts?.length > 1) {
        values.push(parts.slice(1).join(':').trim());
      }
    });
    return values.join(', ');
  }

  fixEncoding(text: string): string {
    if (!text) return '';
    if (!this.browser.doc) return '';
    const txt = this.browser.doc.createElement('textarea');
    txt.innerHTML = text;
    return txt.value
      .replace(/&Atilde;&#151;/g, '×')
      .replace(/Ã—/g, '×')
      .replace(/\s+/g, ' ')
      .trim();
  }

  setInitialAddToCartButtons(): void {
    this.addToCartButtons = {};
    for (const product of this.productDetailsData) {
      if (product?.product_variation_key) {
        this.addToCartButtons[product.product_variation_key] = true;
      }
    }
  }

  syncCartButtonStates(): void {
    const orderItemsList = this.cartService.getOrderItemsList();
    if (orderItemsList) {
      for (const product of this.productDetailsData) {
        const variationKey = product?.product_variation_key;
        if (variationKey && orderItemsList[variationKey]) {
          this.addToCartButtons[variationKey] = false;
        }
      }
    }
  }

  calculateProductRatings(): void {
    for (let i = 0; i < this.productDetailsData?.length; i++) {
      const product = this.productDetailsData[i];
      let avgRating = 0;
      let reviewsCount = 0;
      if (product?.reviews && product.reviews?.length > 0) {
        reviewsCount = product.reviews?.length;
        const sum = product.reviews.reduce((acc: number, review: any) => {
          const scores = [
            +review.appearance || 0,
            +review.installation || 0,
            +review.price_value || 0,
            +review.quality || 0,
          ];
          const reviewAvg = scores.reduce((a, b) => a + b, 0) / scores?.length;
          return acc + reviewAvg;
        }, 0);
        avgRating = sum / reviewsCount;
      }
      product.avgRating = avgRating;
      product.reviewsCount = reviewsCount;
    }
  }

  getCategoryProductFilterData(): void {
    const data: CategoryProductFilter = {
      product_keys: this.initial_product_keys,
      total_products: this.initial_total_products,
      is_universal: this.globalUniversalFilterSetting
    };
    this.categoryProductService.categoryProductFilterList(data).subscribe({
      next: (response: any) => {
        if (response[0].success) {
          const filters = response[0].data;
          this.dynamicFilters = Object.keys(filters)
            .filter(key => key !== 'size' && key !== 'feature')
            .filter(key => !(this.subCategoryData?.length > 0 && (key === 'color' || key === 'universal' || filters[key].filter_source === 'custom')))
            .map(key => ({
              key,
              title: this.capitalize(key),
              filter_source: filters[key].filter_source,
              items: this.mapAndSort(filters[key]),
              showAll: false
            }));
          this.dynamicFilters.forEach((f) => {
            if (!this.selectedFilters[f.key]) {
              this.selectedFilters[f.key] = [];
            }
            if (f.key === 'brand' && this.brand_keys?.length > 0) {
              this.selectedFilters[f.key] = [...this.brand_keys];
            } else if (f.key === 'color' && this.color_keys?.length > 0) {
              this.selectedFilters[f.key] = [...this.color_keys];
            } else if (f.key === 'size' && this.size_keys?.length > 0) {
              this.selectedFilters[f.key] = [...this.size_keys];
            } else if (f.key === 'feature' && this.feature_keys?.length > 0) {
              this.selectedFilters[f.key] = [...this.feature_keys];
            }else if(f.key === 'universal' && this.universalFilter?.length > 0){
              this.selectedFilters[f.key] = [...this.universalFilter];
            } else if (f.filter_source === 'custom' && this.custom_filter_keys?.length > 0) {
              this.selectedFilters[f.key] = [...this.custom_filter_keys];
            }
            if (this.showAllMap[f.key] === undefined) {
              this.showAllMap[f.key] = false;
            }
          });
          this.updateFilterChips();
          this.filterSequencyCategotyVise(this.dynamicFilters);
        }
      }
    });
  }

  filterSequencyCategotyVise(dynamicFilters : any[]){
    if(this.categoryData.parent_category_key == 0){
      this.dynamicFilters.sort((a: any, b: any) => {
        const priority = ['Part Type', 'brand'];
        const aIndex = priority.indexOf(a.key);
        const bIndex = priority.indexOf(b.key);
        return (aIndex === -1 ? 999 : aIndex) -
              (bIndex === -1 ? 999 : bIndex);
      });
    }
  }

  getVisibleItems(filter: any): any[] {
    return filter.showAll ? filter.items : filter.items.slice(0, 6);
  }

  toggleShowMore(filter: any): void {
    filter.showAll = !filter.showAll;
  }

  mapAndSort(obj: Record<string, unknown> | undefined): { id: string, name: string }[] {
    if (!obj) return [];
    return Object.entries(obj)
      .filter(([key]) => key !== 'filter_source')
      .map(([id, name]) => ({
        id,
        name: String(name)
      }))
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base'
        })
      );
  }

  productRedirection(event: any): void {
    const price = Number(event?.price);
    this.gtmService.pushEvent('view_item', {
      ecommerce: {
        currency: 'USD',
        value: price,
        items: [
          {
            item_id: event?.product_variation_key,
            item_name: event?.product_name,
            item_brand: event?.brand[0]?.brand_name,
            item_category: event?.category_name,
            value: price
          }
        ]
      }
    });
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const productKey = event?.product_key;
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    this.commonService.productRedirection(event.product_name, event.product_key);
    // setTimeout(() => {
    //   window.scrollTo(0, 0);
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    // }, 100);
  }

  productRedirectionWithColor(product: any, color: any): void {
    const price = Number(product?.price);
    this.gtmService.pushEvent('view_item', {
      ecommerce: {
        currency: 'USD',
        value: price,
        items: [
          {
            item_id: product?.product_variation_key,
            item_name: product?.product_name,
            item_brand: product?.brand[0]?.brand_name,
            item_category: product?.category_name,
            value: price
          }
        ]
      }
    });
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const productKey = product?.product_key;
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    this.commonService.productRedirection(product.product_name, product.product_key, color.color_key);
    // setTimeout(() => {
    //   window.scrollTo(0, 0);
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    // }, 100);
  }

  getProductFinalPrice(product: any): {
    originalPrice?: number;
    finalPrice?: number;
    rangePrice?: string;
  } {
    const price = +product?.price;
    const msrp = +product?.msrp_price || 0;
    if (product.price === null) {
      const minPrice = +product?.min_price || 0;
      const maxPrice = +product?.max_price || 0;
      const range =
        minPrice === maxPrice
          ? `$${minPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : `$${minPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - $${maxPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      return { rangePrice: range };
    }
    if (product?.promotions) {
      const discount = +product.promotions.discount || 0;
      const type = product.promotions.promotion_type;
      let finalPrice = price;
      if (type === 'percentage_discount') {
        finalPrice = price - (price * discount) / 100;
      } else if (type === 'discount_flat_rate') {
        finalPrice = price - discount;
      }
      return {
        originalPrice: price,
        finalPrice: finalPrice > 0 ? +finalPrice.toFixed(2) : 0,
      };
    }
    return {
      finalPrice: price,
      originalPrice: msrp > price ? msrp : undefined
    };
  }

  getAffirmPrice(product: any): number {
    const priceInfo = this.getProductFinalPrice(product);
    if (product?.price) {
      return Math.round((priceInfo?.finalPrice || 0) * 100);
    } else {
      const minPrice = this.extractMinRangeValue(priceInfo?.rangePrice);
      return Math.round((minPrice || 0) * 100);
    }
  }

  getPaypalPrice(product: any): number {
    const priceInfo = this.getProductFinalPrice(product);
    if (product?.price) {
      return Math.round(priceInfo?.finalPrice || 0);
    } else {
      const minPrice = this.extractMinRangeValue(priceInfo?.rangePrice);
      return Math.round(minPrice || 0);
    }
  }

  extractMinRangeValue(rangePrice?: string): number {
    if (!rangePrice) return 0;
    const match = rangePrice.match(/\$?(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : 0;
  }

  addToCart(product: any): void {
    this.order_key = +this.browser.localStorage?.getItem('orderId') || null;
    const variationKey = product?.product_variation_key;
    if (!variationKey) return;
    const isNewProductFreight = product?.is_freight_shipping == 1;
    const cartShippingType = this.cartService.getCartShippingType();
    if (cartShippingType !== null) {
      const cartIsFreight = cartShippingType === 'freight';
      if (cartIsFreight !== isNewProductFreight) {
        this.dialog.open(CartVerifyPopupComponent, {
          data: {
            messages: [cartIsFreight ? 'Your cart contains freight shipping items. Only freight shipping products can be added.' : 'Your cart contains standard shipping items. Only standard shipping products can be added.'],
            isFreight: cartIsFreight
          }
        });
        return;
      }
    }
    this.disableCheckoutButton = true;
    this.cartService.addToCart(
      {
        product_key: product?.product_key,
        product_variation_key: variationKey,
        sku: product?.sku,
        customer_price: product?.price,
        promotion_key: product?.promotions ? product?.promotions?.promotion_key : 0,
      },
      this.order_key,
      1,
      Number(product?.price),
      product?.promotions ? product?.promotions?.promotion_key : null,
      false,
      '',
      false
    );
    this.gtmService.pushEvent('add_to_cart', {
      ecommerce: {
        currency: 'USD',
        value: Number(product?.price),
        items: [
          {
            item_id: variationKey,
            item_name: product?.product_name,
            item_brand: product?.brand[0]?.brand_name,
            item_category: product?.category_name,
            price: Number(product?.price),
            quantity: 1
          }
        ]
      }
    });
    this.comm.itemCount.next(null);
    this.addToCartButtons[variationKey] = false;
    this.disableCheckoutButton = false;
    this.cartService.setCartShippingType(isNewProductFreight);
    // setTimeout(() => {
    //   window.scrollTo(0, 0);
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    // }, 100);
  }

  onDynamicFilterChange(filterKey: string, id: string, event: any) {
    this.isLoading = true;
    if (event.target.checked) {
      this.selectedFilters[filterKey].push(id);
    } else {
      this.selectedFilters[filterKey] =
        this.selectedFilters[filterKey].filter(x => x !== id);
    }
    this.brand_keys = [];
    this.color_keys = [];
    this.size_keys = [];
    this.feature_keys = [];
    this.custom_filter_keys = [];
    this.part_types = [];
    this.dynamicFilters.forEach(filter => {
      const values = this.selectedFilters[filter.key] || [];
      if (filter.filter_source === 'custom') {
        this.custom_filter_keys.push(...values);
      } else {
         this.scrollToProdSec = true;
        switch (filter.key) {
          case 'brand':
            this.brand_keys = values;
            break;
          case 'color':
            this.color_keys = values;
            break;
          case 'size':
            this.size_keys = values;
            break;
          case 'feature':
            this.feature_keys = values;
            break;
          case 'universal':
            this.universalFilter = values;
            break;
          case 'Part Type':
            this.part_types = values;
            break;
        }
      }
    });
    this.updateFilterChips();
    this.updateSorting();
  }

  updatePriceRange(event: Event, value: string): void {
    this.isLoading = true;
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedPriceRanges.push(value);
    } else {
      this.selectedPriceRanges = this.selectedPriceRanges.filter(r => r !== value);
    }
    this.price_ranges = this.selectedPriceRanges;
    this.updateFilterChips();
    this.updateSorting();
  }

  scrollToProducts(): void {
    const width = this.browser.window?.innerWidth;
    if (width >= 768){
      if (this.productSectionId?.nativeElement) {
        // const stickyHeader = document.querySelector('.sticky-header') as HTMLElement;
        // const headerHeight = stickyHeader?.offsetHeight || 120;
        const elementTop = this.productSectionId.nativeElement.getBoundingClientRect().top;
        //const scrollPosition = window.pageYOffset + elementTop - headerHeight - 73;
        const scrollPosition = this.browser.window?.pageYOffset + elementTop - 115;
        this.browser.window?.scrollTo({
          top: scrollPosition,
          behavior: 'auto',
        });
      }
    }else{
      if (this.breadcrumbSectionId?.nativeElement) {
        const elementTop = this.breadcrumbSectionId.nativeElement.getBoundingClientRect().top;
        const scrollPosition = this.browser.window?.pageYOffset + elementTop - 115;
        this.browser.window?.scrollTo({
          top: scrollPosition,
          behavior: 'auto',
        });
      }
    }
  }

  updateSorting(): void {
    this.scrollToProdSec = true;
    this.resetPagination();
    this.getCategoryProductData();
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    const name = this.commonService.setUrlNameField(this.categoryData.category_name).toLowerCase();
    this.router.navigate([`/${name}/c${this.categoryData.category_key}/page/${page}`], {
      queryParams: { brandKey: this.brand_keys, colorKey: this.color_keys, sizeKey: this.size_keys, featureKey: this.feature_keys, customFilterKey: this.custom_filter_keys, partType: this.part_types, priceRange: this.price_ranges, selectedFilters: JSON.stringify(this.selectedFilters), universal: this.universalFilter},
    });
  }

  getGroupedPages(): number[] {
    const groupSize = this.paginationGroupSize;
    const pages: number[] = [];
    const groupIndex = Math.floor((this.currentPage - 1) / groupSize);
    const startPage = groupIndex * groupSize + 1;
    const endPage = Math.min(startPage + groupSize - 1, this.totalPages);
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    if (endPage < this.totalPages) {
      pages.push(-1);
      pages.push(this.totalPages);
    }
    return pages;
  }

  get productRangeText(): string {
    const start = (this.currentPage - 1) * this.limit + 1;
    let end = this.currentPage * this.limit;
    if (end > this.total_products) {
      end = this.total_products;
    }
    return `${start}-${end} of ${this.total_products} Product${this.total_products !== 1 ? 's' : ''}`;
  }

  onThumbnailClick(product: any, index: number): void {
    product.selectedImageIndex = index;
  }

  openLoveItPopup(product: any): void {
    this.browser.localStorage?.setItem('selectedproductkey', String(product.product_key));
    this.browser.localStorage?.setItem('selectedProductName', product.product_name);
    this.dialog.open(LoveItPopupComponent,  {
      data: { product_name: product.product_name, prod_description: product?.short_description, prod_image: product?.product_photos[0]?.medium_image, product_key:product?.product_key },
    });
  }

  openVechicleSearchPopup(): void {
    this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog',
    });
  }

  onProductImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = `${this.commonImagePath}image_not_found.webp`;
  }

  resetPagination(): void {
    this.currentPage = 1;
    this.offset = 0;
    this.totalPagesArray = this.getGroupedPages();
  }

  resetFilters(): void {
    this.brand_keys = [];
    this.color_keys = [];
    this.size_keys = [];
    this.feature_keys = [];
    this.custom_filter_keys = [];
    this.part_types = [];
    this.selectedPriceRanges = [];
    this.price_ranges = [];
    this.resetPagination();
  }

  subCategoriesRedirection(event: any): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.commonService.categoryRedirection(event.category_name, event.category_key);
  }

  clearVehicle() {
    this.searchByVehicleService.clearVehicleSearch();
  }

  getCleanProductName(name: string): string {
    return name.replace(/\\/g, '');
  }

  capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  openWishlist(product: any): void {
    const data: wishlistPostDataInterface = {
      qty: 1,
      calculated_price: product.price,
      product_variation_key: product.product_variation_key,
      save_for_later: false,
    };
    this.productHttp.wishlist(data).subscribe({
      next: (response) => {
        if (
          response.status === 'Token is Invalid' ||
          response.status === 'Token is Expired' ||
          response.status == 'Authorization Token not found'
        ) {
          this.router.navigate(['/customer-login']);
        } else if (response[0].data === "Your item has been added to your list.") {
          const price = Number(product?.price) || 0;
          this.gtmService.pushEvent('add_to_wishlist', {
            ecommerce: {
              currency: 'USD',
              value: price,
              items: [
                {
                  item_id: product?.product_variation_key,
                  item_name: product?.product_name,
                  item_brand: product?.brand[0]?.brand_name,
                  item_category: product?.category_name,
                  price: price,
                  quantity: 1
                }
              ]
            }
          });
          let wishItems = Number(this.browser.localStorage?.getItem('wishlistItem')) || 0;
          wishItems = wishItems + 1;
          this.browser.localStorage?.setItem('wishlistItem', String(wishItems));
          this.comm.setCount(wishItems);
          this.openWishlistSuccess();
        } else {
          this.openWishlistSuccess();
        }
      },
      error: (error: Error) => {
        this.router.navigate(['/customer-login']);
        console.error('Custom Error: Unexpected Error while fetching wishlist', error);
      },
    });
  }

  openWishlistSuccess(): void {
    const dialogRef = this.dialog.open(WishlistPopupComponent, {
      width: '250px',
      data: { message: 'Product added to wishlist successfully.' },
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  onContactClick(product: any) {
    this.router.navigate(['/contact-us'], {
      queryParams: { subject: `${product.product_name}` },
    });
  }

  getSideMenuLogo(): string {
    const storedData = this.headerService.getStoredHeaderData();
    if (!storedData) {
      return this.imageBasePath + 'logomobile.webp';
    }
    const headerData = storedData[0]?.data;
    const logo = headerData?.websiteHeader?.[2]?.website_side_menu_logo;
    return logo ? this.cdnImagePath + logo : this.imageBasePath + 'logomobile.webp';
  }

  getInventoryData(item: any): {
    qty: number;
    isInStock: boolean;
    warehouse: 'karls' | 'partner';
    karlsQty: number;
  } {
    const qtyArr = (item?.fulfillment_qty || '').split(',').map(Number);
    const branchArr = (item?.fulfillment_branch_id || '').split(',');
    const distributorArr = (item?.fulfillment_distributors || '').split(',');
    let totalQty = 0;
    let karlsQty = 0;
    for (let i = 0; i < qtyArr?.length; i++) {
      const qty = qtyArr[i] || 0;
      const branch = branchArr[i];
      const distributor = distributorArr[i];
      totalQty += qty;
      if (branch === 'r&r' || distributor === 'karlkustoms') {
        karlsQty += qty;
      }
    }
    const warehouse: 'karls' | 'partner' = karlsQty > 0 ? 'karls' : 'partner';
    return {
      qty: totalQty,
      isInStock: totalQty > 0,
      warehouse,
      karlsQty
    };
  }

  getInventoryMessages(
    qty: number,
    isInStock: boolean,
    warehouse: 'karls' | 'partner' = 'karls',
    karlsQty: number = 0
  ) {
    const now = new Date();
    const cstTime = new Date(
      now.toLocaleString('en-US', { timeZone: 'America/Chicago' })
    );
    const day = cstTime.getDay();
    const hours = cstTime.getHours();
    const isSaturday = day === 6;
    const isSunday = day === 0;
    const isWeekday = day >= 1 && day <= 5;
    const before3PM = hours < 15;
    const beforeNoon = hours < 12;
    const after8AM = hours >= 8;
    let availabilityMsg = '';
    let urgencyMsg = '';
    let pickupMsg = '';
    if (!isInStock || Number(qty) <= 0) {
      return {
        availabilityMsg: 'Ships from Supplier in 2 to 4 Weeks (Pending Availability)',
        urgencyMsg: '',
        pickupMsg: 'Local pickup not available',
        showBackorder: true,
      };
    }
    if (qty <= 5) {
      urgencyMsg = `Only ${qty} left, order soon`;
    }
    if (karlsQty <= 0) {
      pickupMsg = 'Local pickup not available';
    }
    if (warehouse === 'karls') {
      const isAfterSatNoon = isSaturday && !beforeNoon;
      const isBeforeMon8AM = day === 1 && !after8AM;
      if (isAfterSatNoon || isSunday) {
        availabilityMsg = isSunday ? 'In Stock, expected to ship tomorrow' : 'In Stock ships Monday';
        if (karlsQty > 0) {
          pickupMsg = 'Local pick-up available Monday morning from 8AM to 12PM CST';
        } else {
          pickupMsg = 'Local pickup not available';
        }
        return {
          availabilityMsg,
          urgencyMsg,
          pickupMsg,
          showBackorder: false,
        };
      }
      if (isBeforeMon8AM) {
        availabilityMsg = 'In Stock, expected to ship today';
        if (karlsQty > 0) {
          pickupMsg = 'Local pick-up available today from 8AM to 5PM CST';
        } else {
          pickupMsg = 'Local pickup not available';
        }
        return {
          availabilityMsg,
          urgencyMsg,
          pickupMsg,
          showBackorder: false,
        };
      }
      if (isWeekday) {
        availabilityMsg = before3PM ? 'In Stock, expected to ship today' : 'In Stock, expected to ship tomorrow';
        if (karlsQty > 0) {
          pickupMsg = `${karlsQty} available for local pickup at Karl Kustoms in Des Moines, IA from 8AM to 5PM CST`;
        }
      }
      if (isSaturday) {
        availabilityMsg = 'In Stock ships Monday';
        if (!after8AM) {
          pickupMsg = karlsQty > 0 ? 'Local pick-up available Monday morning from 8AM to 12PM CST' : 'Local pickup not available';
        } else if (beforeNoon) {
          pickupMsg = karlsQty > 0 ? `${karlsQty} available for local pickup at Karl Kustoms in Des Moines, IA from 8AM to 12PM CST` : 'Local pickup not available';
        }
      }
    }
    if (warehouse === 'partner') {
      if (isWeekday) {
        availabilityMsg = before3PM ? 'In Stock, expected to ship today' : 'In Stock, expected to ship tomorrow';
      }
      if (isSaturday) {
        availabilityMsg = 'In Stock ships today or Monday';
      }
      if (isSunday) {
        availabilityMsg = 'In Stock, expected to ship tomorrow';
      }
    }
    return {
      availabilityMsg,
      urgencyMsg,
      pickupMsg,
      showBackorder: false,
    };
  }

  getPickupMsgHtml(product: any): SafeHtml {
    const inv = this.getInventoryData(product);
    const msg = this.getInventoryMessages(inv.qty, inv.isInStock, inv.warehouse, inv.karlsQty)?.pickupMsg || '';
    const html = msg
      .replace(/^(\d+ available for local pickup)/, '<span style=" font-family:var(--font-secondary-bold)">$1</span>')
      .replace('at Karl Kustoms', '<span style="font-family:var(--font-secondary-bold)"><strong><u>at Karl Kustoms</u></strong></span>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getPrimaryPhoto(productPhotos: any[], selectedImageIndex: number = undefined): string {
    if (!productPhotos?.length) {
      return null;
    }
    if (selectedImageIndex !== undefined && productPhotos[selectedImageIndex]) {
      return productPhotos[selectedImageIndex].medium_image;
    }
    const primaryImage = productPhotos.find((photo) => photo.primary_photo === 1);
    return primaryImage ? primaryImage.medium_image : productPhotos[0].medium_image;
  }

  getSortedFilterItems(filter: any): any[] {
    if (!filter?.items) return [];
    return [...filter.items].sort((a, b) => {
      const aSelected = this.selectedFilters[filter.key]?.includes(a.id);
      const bSelected = this.selectedFilters[filter.key]?.includes(b.id);
      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;
      return 0;
    });
  }

  getSelectedFilterChips(): { filterKey: string; filterTitle: string; itemId: string; itemName: string }[] {
    const chips: { filterKey: string; filterTitle: string; itemId: string; itemName: string }[] = [];
    this.dynamicFilters.forEach(filter => {
      const selectedIds = this.selectedFilters[filter.key] || [];
      selectedIds.forEach(id => {
        const item = filter.items.find((i: any) => i.id === id);
        if (item) {
          chips.push({
            filterKey: filter.key,
            filterTitle: filter.title,
            itemId: id,
            itemName: item.name
          });
        }
      });
    });
    this.selectedPriceRanges.forEach(range => {
      const priceRange = this.priceRanges.find(r => r.value === range);
      if (priceRange) {
        chips.push({
          filterKey: 'price',
          filterTitle: 'Price',
          itemId: range,
          itemName: priceRange.label
        });
      }
    });
    return chips;
  }

  removeFilterChip(filterKey: string, itemId: string): void {
    this.isLoading = true;
    if (filterKey === 'price') {
      this.selectedPriceRanges = this.selectedPriceRanges.filter(r => r !== itemId);
      this.price_ranges = this.selectedPriceRanges;
    } else {
      this.selectedFilters[filterKey] = this.selectedFilters[filterKey].filter(id => id !== itemId);
      const filter = this.dynamicFilters.find(f => f.key === filterKey);
      if (filter) {
        if (filter.filter_source === 'custom') {
          this.custom_filter_keys = this.custom_filter_keys.filter(k => k !== itemId);
        } else {
          switch (filterKey) {
            case 'brand':
              this.brand_keys = this.brand_keys.filter(k => k !== itemId);
              break;
            case 'color':
              this.color_keys = this.color_keys.filter(k => k !== itemId);
              break;
            case 'size':
              this.size_keys = this.size_keys.filter(k => k !== itemId);
              break;
            case 'feature':
              this.feature_keys = this.feature_keys.filter(k => k !== itemId);
              break;
            case 'Part Type':
              this.part_types = this.part_types.filter(k => k !== itemId);
              break;
            case 'universal':
              this.universalFilter = this.universalFilter.filter(k => k !== itemId);
              break;
          }
        }
      }
    }
    this.updateFilterChips();
    this.updateSorting();
  }

  updateFilterChips(): void {
    this.selectedFilterChips = this.getSelectedFilterChips();
  }

  clearAllFilters(): void {
    this.resetFilters();
    this.selectedFilters = {};
    this.dynamicFilters.forEach(f => {
      this.selectedFilters[f.key] = [];
    });
    this.updateFilterChips();
    this.updateSorting();
  }

  openProductAdmin(productKey: number | string): void {
    const adminUrl = `https://${this.merchantProductUrl}${productKey}`;
    this.browser.window?.open(adminUrl, '_blank');
  }

  ngOnDestroy(): void {
    if (this.browser.isBrowser) {
      const sidebarEl = this.browser.doc?.getElementById('categoryProdFilter');
      if (sidebarEl) {
        sidebarEl.removeEventListener('show.bs.offcanvas', this.showListener);
        sidebarEl.removeEventListener('hide.bs.offcanvas', this.hideListener);
        sidebarEl.removeEventListener('hidden.bs.offcanvas', this.hiddenListener);
      }
    }
    if (!!this.categoryKeyChangeSub) {
      this.categoryKeyChangeSub.unsubscribe();
    }
    this.cancelApiCall$.next();
    this.cancelApiCall$.complete();
  }
}